var _path, _mask, _rect, _mask2, _rect2, _mask3, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect10, _rect11, _rect12, _rect13, _rect14, _rect15;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgViseits11(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 81,
    height: 52,
    viewBox: "0 0 81 52",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M70 4.5H10C8.89543 4.5 8 5.39543 8 6.5V44.5H72V6.5C72 5.39543 71.1046 4.5 70 4.5ZM6 6.5V44.5H1.81949C1.03086 44.5 0.552567 45.3702 0.975278 46.036L1.7931 47.3241C2.32507 48.1619 2.98319 48.8934 3.73399 49.5H1C0.447715 49.5 0 49.9477 0 50.5C0 51.0523 0.447714 51.5 0.999999 51.5H9.39101H70.6091H79C79.5523 51.5 80 51.0523 80 50.5C80 49.9477 79.5523 49.5 79 49.5H76.2661C77.0169 48.8934 77.675 48.1619 78.207 47.3241L79.0248 46.036C79.4475 45.3702 78.9692 44.5 78.1806 44.5H74V6.5C74 4.29086 72.2091 2.5 70 2.5H10C7.79086 2.5 6 4.29086 6 6.5ZM6 46.5H74H76.3537C75.0488 48.3744 72.9054 49.5 70.6091 49.5H9.39101C7.0947 49.5 4.95126 48.3744 3.64643 46.5H6ZM12 40.5V8.5H68V40.5H12ZM10 7.5C10 6.94772 10.4477 6.5 11 6.5H69C69.5523 6.5 70 6.94772 70 7.5V41.5C70 42.0523 69.5523 42.5 69 42.5H11C10.4477 42.5 10 42.0523 10 41.5V7.5Z",
    fill: "#CBD4D5"
  })), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "a",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 15,
    y: 11.5,
    width: 50,
    height: 6,
    rx: 1
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 15,
    y: 11.5,
    width: 50,
    height: 6,
    rx: 1,
    fill: "#2156FA",
    stroke: "#2156FA",
    strokeWidth: 4,
    mask: "url(#a)"
  })), _mask2 || (_mask2 = /*#__PURE__*/React.createElement("mask", {
    id: "b",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 15,
    y: 19.5,
    width: 16,
    height: 18,
    rx: 1
  }))), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 15,
    y: 19.5,
    width: 16,
    height: 18,
    rx: 1,
    stroke: "#010334",
    strokeWidth: 4,
    mask: "url(#b)"
  })), _mask3 || (_mask3 = /*#__PURE__*/React.createElement("mask", {
    id: "c",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 33,
    y: 19.5,
    width: 32,
    height: 18,
    rx: 1
  }))), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 33,
    y: 19.5,
    width: 32,
    height: 18,
    rx: 1,
    stroke: "#010334",
    strokeWidth: 4,
    mask: "url(#c)"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 11,
    y: 0.5,
    width: 2,
    height: 4,
    rx: 1,
    fill: "#2156FA"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 11,
    y: 6.5,
    width: 2,
    height: 4,
    rx: 1,
    fill: "#2156FA"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 17,
    y: 4.5,
    width: 2,
    height: 4,
    rx: 1,
    transform: "rotate(90 17 4.5)",
    fill: "#2156FA"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 11,
    y: 4.5,
    width: 2,
    height: 4,
    rx: 1,
    transform: "rotate(90 11 4.5)",
    fill: "#2156FA"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 75,
    y: 11.5,
    width: 2,
    height: 4,
    rx: 1,
    fill: "#2156FA"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 75,
    y: 17.5,
    width: 2,
    height: 4,
    rx: 1,
    fill: "#2156FA"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 81,
    y: 15.5,
    width: 2,
    height: 4,
    rx: 1,
    transform: "rotate(90 81 15.5)",
    fill: "#2156FA"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 75,
    y: 15.5,
    width: 2,
    height: 4,
    rx: 1,
    transform: "rotate(90 75 15.5)",
    fill: "#2156FA"
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 22,
    y: 4.5,
    width: 2,
    height: 4,
    rx: 1,
    fill: "#2156FA"
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    x: 22,
    y: 6.5,
    width: 2,
    height: 4,
    rx: 1,
    fill: "#2156FA"
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    x: 26,
    y: 6.5,
    width: 2,
    height: 4,
    rx: 1,
    transform: "rotate(90 26 6.5)",
    fill: "#2156FA"
  })), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    x: 24,
    y: 6.5,
    width: 2,
    height: 4,
    rx: 1,
    transform: "rotate(90 24 6.5)",
    fill: "#2156FA"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgViseits11);
export default __webpack_public_path__ + "static/media/viseits11.affe8825433ac2738a182985b12a07fe.svg";
export { ForwardRef as ReactComponent };